import React from 'react'

const SocketContext = React.createContext({
  messageData: {},
  sendMessage: (object) => { },
})

export default SocketContext